import type {CodeListId} from 'domainTypes';
import type {Schema} from 'schemaDefinition/types';
import {getPartCodelistId} from 'schemaDefinition/functions/getPartCodelistId';
import {visitSchemaParts} from 'schemaDefinition/functions/visitSchemaParts';
import type {LinkedRoleCodeListId} from 'schemaDefinition/types/linkTypes';

export const getSchemaListCodelistIds = (
  schemas: Schema[],
): (CodeListId | LinkedRoleCodeListId)[] => {
  const acutalSchemas = schemas.filter(Boolean) as Schema[];
  if (acutalSchemas.length === 0) {
    return [];
  }

  const codelists: (CodeListId | LinkedRoleCodeListId)[] = [];

  acutalSchemas.forEach(schema =>
    visitSchemaParts(schema, part => {
      const partCodelistIds = getPartCodelistId(part);
      partCodelistIds?.forEach(partCodelistId => {
        if (!codelists.includes(partCodelistId)) {
          codelists.push(partCodelistId);
        }
      });
    }),
  );

  return codelists;
};
